import * as wjcCore from '@mescius/wijmo';

'use strict';

import {Component, AfterViewInit, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {Store} from "@ngrx/store";
import {ToasterService} from "angular2-toaster";
import {ActivePromotionConfig} from "../config/active-promotion.config";
import {asOrientDate, isOrientDate, DataService, OrientDBCollectionView} from "@cosbeni/database";
import {WebsocketOneService} from "../services/websocket.one.service";
import {WebsocketTwoService} from "../services/websocket.two.service";
import {Observable} from 'rxjs';
import {LoadUserAction} from "../ngrx/actions/user.action";
import {GalleryComponent, GalleryItem, ImageItem} from '../ui/gallery/index';

export interface IMessage {
    id: number;
    text: string;
}

@Component({
    standalone: false,
    selector: 'cj-user-live',
    templateUrl: 'live.component.html',
})

export class LiveComponent implements OnInit, OnDestroy {
    @ViewChild('imageGalleryOne') imageGalleryOne: GalleryComponent;
    @ViewChild('imageGalleryTwo') imageGalleryTwo: GalleryComponent;
    screenWidth: number;
    timeMin: Date = new Date(2000, 1, 1, 9, 0, 0);
    user;
    auctionIdOne: string = "";
    auctionOne: any;
    itemIdOne: string = "";
    nextItemIdOne: string = "";
    buyerOne: string = "";
    priceOne: number = 0;
    statusOne: string = "";
    indexOne: number = 0;
    sizeOne: number = 0;
    bidsOne: number = 0;
    countOne: number = 0;
    itemOne: any = {};
    nextItemOne: any = {};
    mapItemsOne: any = {};
    galleryItemsOne: GalleryItem[];
    auctionOne$: Observable<any>;
    countOne$: Observable<any>;
    auctionIdTwo: string = "";
    auctionTwo: any;
    itemIdTwo: string = "";
    nextItemIdTwo: string = "";
    buyerTwo: string = "";
    priceTwo: number = 0;
    statusTwo: string = "";
    indexTwo: number = 0;
    sizeTwo: number = 0;
    bidsTwo: number = 0;
    countTwo: number = 0;
    itemTwo: any = {};
    nextItemTwo: any = {};
    mapItemsTwo: any = {};
    galleryItemsTwo: GalleryItem[];
    auctionTwo$: Observable<any>;
    countTwo$: Observable<any>;
    message: string;

    constructor(public store: Store<any>, public dataService: DataService, public toasterService: ToasterService, private route: ActivatedRoute, private websockeOneService: WebsocketOneService, private websockeTwoService: WebsocketTwoService) {
        this.store.dispatch(new LoadUserAction())
        this.store.select<any>("activePromotionFeature").subscribe((digitalAuction: any) => {
            if (wjcCore.isObject(digitalAuction.user) && digitalAuction.user.loaded) {
                this.user = digitalAuction.user.user;
            }
        });
    }

    ngOnInit() {
        this.websockeOneService.status.subscribe(status => {
            if (status)
                this.websockeOneService.send('init', {})
        })
        if(ActivePromotionConfig.debug){
            this.auctionIdOne = "#178:4";
            this.getAuctionOne();
        }
        this.auctionOne$ = this.websockeOneService.on<any>('auction');
        this.countOne$ = this.websockeOneService.on<any>("count");
        this.auctionOne$.subscribe((data) => {
                if (!wjcCore.isNullOrWhiteSpace(data)) {
                    this.auctionIdOne = data;
                    this.getAuctionOne();
                }
            }
        )
        this.countOne$.subscribe((data) => {
                if (wjcCore.isObject(data)) {
                    if (!wjcCore.isNullOrWhiteSpace(data.auction) && this.auctionIdOne != data.auction) {
                        this.auctionIdOne = data.auction;
                        this.getAuctionOne();
                    }
                    if (!wjcCore.isNullOrWhiteSpace(data.current) && this.mapItemsOne.hasOwnProperty(data.current) && this.itemIdOne != data.current) {
                        this.itemIdOne = data.current;
                        this.nextItemIdOne = data.next;
                        this.itemOne = this.mapItemsOne[this.itemIdOne];
                        this.nextItemOne = this.mapItemsOne[this.nextItemIdOne];
                        this.indexOne = data.index;
                        this.sizeOne = data.size;
                        if (wjcCore.isObject(this.imageGalleryOne))
                            this.imageGalleryOne.reset();
                        if (this.itemOne.hasOwnProperty("images") && wjcCore.isArray(this.itemOne.images)) {
                            this.galleryItemsOne = [];
                            for (let name of this.itemOne.images) {
                                this.galleryItemsOne.push(new ImageItem({
                                    src: ActivePromotionConfig.IMAGE_URL + this.itemOne.id + '/' + name,
                                    thumb: ActivePromotionConfig.IMAGE_URL + this.itemOne.id + '/' + name
                                }))
                            }
                        }
                    }
                    if (!wjcCore.isNullOrWhiteSpace(data.current) && this.mapItemsOne.hasOwnProperty(data.current) && this.buyerOne != data.buyer) {
                        this.buyerOne = data.buyer;
                    }
                    if (!wjcCore.isNullOrWhiteSpace(data.current) && this.mapItemsOne.hasOwnProperty(data.current) && this.priceOne != data.price) {
                        this.priceOne = data.price;
                    }
                    if (!wjcCore.isNullOrWhiteSpace(data.current) && this.mapItemsOne.hasOwnProperty(data.current) && this.statusOne != data.status) {
                        this.statusOne = data.status;
                    }
                    if (!wjcCore.isNullOrWhiteSpace(data.current) && this.mapItemsOne.hasOwnProperty(data.current) && this.bidsOne != data.bids) {
                        this.bidsOne = data.bids;
                    }
                    if (!wjcCore.isNullOrWhiteSpace(data.current) && this.mapItemsOne.hasOwnProperty(data.current) && this.countOne != data.count) {
                        this.countOne = data.count;
                    }
                }
            }
        )
        this.websockeTwoService.status.subscribe(status => {
            if (status)
                this.websockeTwoService.send('init', {})
        })
        this.auctionTwo$ = this.websockeTwoService.on<any>('auction');
        this.countTwo$ = this.websockeTwoService.on<any>("count");
        this.auctionTwo$.subscribe((data) => {
                if (!wjcCore.isNullOrWhiteSpace(data)) {
                    this.auctionIdTwo = data;
                    this.getAuctionTwo();
                }
            }
        )
        this.countTwo$.subscribe((data) => {
                if (wjcCore.isObject(data)) {
                    if (!wjcCore.isNullOrWhiteSpace(data.auction) && this.auctionIdTwo != data.auction) {
                        this.auctionIdTwo = data.auction;
                        this.getAuctionTwo();
                    }
                    if (!wjcCore.isNullOrWhiteSpace(data.current) && this.mapItemsTwo.hasOwnProperty(data.current) && this.itemIdTwo != data.current) {
                        this.itemIdTwo = data.current;
                        this.nextItemIdTwo = data.next;
                        this.itemTwo = this.mapItemsTwo[this.itemIdTwo];
                        this.nextItemTwo = this.mapItemsTwo[this.nextItemIdTwo];
                        this.indexTwo = data.index;
                        this.sizeTwo = data.size;
                        if (wjcCore.isObject(this.imageGalleryTwo))
                            this.imageGalleryTwo.reset();
                        if (this.itemTwo.hasOwnProperty("images") && wjcCore.isArray(this.itemTwo.images)) {
                            this.galleryItemsTwo = [];
                            for (let name of this.itemTwo.images) {
                                this.galleryItemsTwo.push(new ImageItem({
                                    src: ActivePromotionConfig.IMAGE_URL + this.itemTwo.id + '/' + name,
                                    thumb: ActivePromotionConfig.IMAGE_URL + this.itemTwo.id + '/' + name
                                }))
                            }
                        }
                    }
                    if (!wjcCore.isNullOrWhiteSpace(data.current) && this.mapItemsTwo.hasOwnProperty(data.current) && this.buyerTwo != data.buyer) {
                        this.buyerTwo = data.buyer;
                    }
                    if (!wjcCore.isNullOrWhiteSpace(data.current) && this.mapItemsTwo.hasOwnProperty(data.current) && this.priceTwo != data.price) {
                        this.priceTwo = data.price;
                    }
                    if (!wjcCore.isNullOrWhiteSpace(data.current) && this.mapItemsTwo.hasOwnProperty(data.current) && this.statusTwo != data.status) {
                        this.statusTwo = data.status;
                    }
                    if (!wjcCore.isNullOrWhiteSpace(data.current) && this.mapItemsTwo.hasOwnProperty(data.current) && this.bidsTwo != data.bids) {
                        this.bidsTwo = data.bids;
                    }
                    if (!wjcCore.isNullOrWhiteSpace(data.current) && this.mapItemsTwo.hasOwnProperty(data.current) && this.countTwo != data.count) {
                        this.countTwo = data.count;
                    }
                }
            }
        )
        this.resizeScreen();
    }

    resizeScreen(event?) {
        this.screenWidth = window.innerWidth;
    }

    ngOnDestroy() {
    }

    beforeAuctionOne(): boolean {
        if (wjcCore.isObject(this.auctionOne) && wjcCore.isNullOrWhiteSpace(this.itemIdOne)) {
            return true;
        }
        return false;
    }

    getAuctionOne() {
        this.dataService.query({
            sql: "SELECT FROM " + this.auctionIdOne,
            count: "SELECT FROM " + this.auctionIdOne,
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results) && data.results.length == 1) {
                this.auctionOne = data.results[0];
                this.dataService.query({
                    sql: "SELECT FROM DA_Item WHERE auction = " + this.auctionIdOne,
                    count: "SELECT FROM  DA_Item WHERE auction = " + this.auctionIdOne,
                    fetchPlan: "*:1",
                }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
                    if (wjcCore.isArray(data.results)) {
                        for (let item of data.results) {
                            this.mapItemsOne[item['@rid']] = item;
                        }
                    }
                    if(ActivePromotionConfig.debug){
                        this.itemIdOne = "#179:3";
                        this.nextItemIdOne =  "#179:4";
                        this.itemOne = this.mapItemsOne[this.itemIdOne];
                        this.statusOne = "スタート";
                        this.nextItemOne = this.mapItemsOne[this.nextItemIdOne];
                        this.indexOne = 0;
                        this.sizeOne = 2;
                        if (wjcCore.isObject(this.imageGalleryOne))
                            this.imageGalleryOne.reset();
                        if (this.itemOne.hasOwnProperty("images") && wjcCore.isArray(this.itemOne.images)) {
                            this.galleryItemsOne = [];
                            for (let name of this.itemOne.images) {
                                this.galleryItemsOne.push(new ImageItem({
                                    src: ActivePromotionConfig.IMAGE_URL + this.itemOne.id + '/' + name,
                                    thumb: ActivePromotionConfig.IMAGE_URL + this.itemOne.id + '/' + name
                                }))
                            }
                        }
                    }
                })
            }
        })
    }

    bidOne(increase): void {
        this.websockeOneService.send('bid', {buyer: this.user['@rid'], item: this.itemIdOne, increase: increase})
    }

    beforeAuctionTwo(): boolean {
        if (wjcCore.isObject(this.auctionTwo) && wjcCore.isNullOrWhiteSpace(this.itemIdTwo)) {
            return true;
        }
        return false;
    }

    getAuctionTwo() {
        this.dataService.query({
            sql: "SELECT FROM " + this.auctionIdTwo,
            count: "SELECT FROM " + this.auctionIdTwo,
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results) && data.results.length == 1) {
                this.auctionTwo = data.results[0];
                this.dataService.query({
                    sql: "SELECT FROM DA_Item WHERE auction = " + this.auctionIdTwo,
                    count: "SELECT FROM  DA_Item WHERE auction = " + this.auctionIdTwo,
                    fetchPlan: "*:1",
                }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
                    if (wjcCore.isArray(data.results)) {
                        for (let item of data.results) {
                            this.mapItemsTwo[item['@rid']] = item;
                        }
                    }
                })
            }
        })
    }

    bidTwo(increase): void {
        this.websockeTwoService.send('bid', {buyer: this.user['@rid'], item: this.itemIdTwo, increase: increase})
    }


    getImageSrc(item, name): string {
        return ActivePromotionConfig.IMAGE_URL + item.id + '/' + name;
    }

}

